// Formats a numeric dollar amount + ISO currency code (as returned by the
// Strategy Credit purchase catalog callables, e.g. getStrategyCreditProducts/
// getManagerStrategyCreditProducts) as a localized currency string. Shared so
// the per-agent and manager-pool "Buy Credits" UIs format prices identically.
export function formatPrice(amount, currency) {
  if (typeof amount !== "number") return "";
  try {
    return new Intl.NumberFormat("en-US", { style: "currency", currency: (currency || "usd").toUpperCase() }).format(amount);
  } catch (e) {
    return `$${amount.toFixed(2)}`;
  }
}
